'use strict';

const Moment = require('moment');
const ReadMore = require('common/ui/view/behavior/readmore');
const ReviewActionCreator = require('notify/domain/action/review');
const NotificationItemView = require('notify/ui/view/item');
const NoNotificationTemplate = require('notify/ui/template/no-notification.hbs');

const ReviewItemView = NotificationItemView.extend({
    onRead: function() {
        ReviewActionCreator.read({
            review: this.model.toJSON()
        });
    },

    onUnread: function() {
        ReviewActionCreator.unread({
            review: this.model.toJSON()
        });
    },

    isNewArrival: function() {
        return Moment(this.model.getCreatedAt()) > this.getOption('latestReadTime')
    }
});

const NoNotificationlView = Backbone.Marionette.View.extend({
    template: NoNotificationTemplate
});

module.exports = Backbone.Marionette.CollectionView.extend({
    childView: ReviewItemView,
    emptyView: NoNotificationlView,
    childViewOptions: function() {
        return {
            read: this.getOption('read'),
            useMarkAsRead: this.getOption('markAsRead'),
            latestReadTime: this.getOption('latestReadTime')
        }
    },
    childViewEvents: {
        'read': 'onChangeRead',
        'unread': 'onChangeRead'
    },
    behaviors: {
        ReadMore: {
            behaviorClass: ReadMore,
            showReadMore: function() {
                return this.collection.length > this._limit;
            },
            onReadMore: function() {
                ReviewActionCreator.fetchReviewsOnce({
                    limit: this._initialLimit + 1,
                    all: this.getOption('read'),
                    oldest: this.collection.at(-1).getEventAt().toISOString()
                });
                this._limit += this._initialLimit + 1;
            }
        }
    },

    initialize: function() {
        this._limit = 9;
        this._initialLimit = this._limit;
    },

    filter: function(child, index) {
        return index < this._limit;
    },

    onChangeRead: function() {
        this._limit -= 1;
    }
});



// WEBPACK FOOTER //
// ./notify/ui/view/review-list.js